import { Link } from 'react-router-dom'
import iconArrowRightBig from '../../../assets/icons/ico-arrow-right-big.png'
import { Item } from './styles'

type NotificationMenuItemProps = {
  icon: any;
  title: string;
  url?: string;
  action?: any;
}

const NotificationMenuItem = ({ icon, title, url, action }: NotificationMenuItemProps) => {
  return (
    <Item title={title} onClick={action}>
      {url
        ? (
          <Link to={url}>
            <div className="notification-menu-item-sections">
              <div className="meta">
                <img src={icon} alt={title} />
                <h3>{title}</h3>
              </div>
              <img className="notifications-menu-arrow" src={iconArrowRightBig} alt="icone de seta" />
            </div>
          </Link>
        )
        : (
          <div>
            <div className="notification-menu-item-sections">
              <div className="meta">
                <img src={icon} alt={title} />
                <h3>{title}</h3>
              </div>
              <img className="notifications-menu-arrow" src={iconArrowRightBig} alt="icone de seta" />
            </div>
          </div>
        )}
    </Item>
  )
}

export default NotificationMenuItem
